<template>
    <async-btn
            :task="task"
            color="primary"
            label="Move to Timeline"
            v-bind="$attrs"
            @click="move"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import notify from '@/components/notify';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { moveToTimeline } from '../post';

interface Data {
  task: Promise<Post>|null,
}

export default defineComponent({
  components: { AsyncBtn },
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    move() {
      this.task = moveToTimeline(this.postId);
      this.task.then(() => {
        notify('Post moved to timeline.');
      });
    },
  },
});
</script>
